import { useQueryClient, useMutation } from 'react-query';
import PhoneHoursApi from '@frontend/api-phone-hours';
import { queryKeys } from '../../query-keys';
import { UpdatePhoneHourTypes } from './types';

export const usePhoneHoursMutations = (phoneTenantId: string) => {
  const queryClient = useQueryClient();

  const update = useMutation({
    mutationFn: (payload: UpdatePhoneHourTypes) => {
      return PhoneHoursApi.UpdatePhoneHour(payload);
    },
    onSettled: () => {
      queryClient.invalidateQueries([phoneTenantId, ...queryKeys.settings.listPhoneHours()]);
    },
  });

  return {
    update,
  };
};
